import { defineComponent } from 'vue';

export default defineComponent({
  delimiters: ['${', '}'],
  props: {
    bulkPriceQuantity: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      distanceForOffer: null,
      upsell: false,
    };
  },
  computed: {
    enabled() {
      return this.isCustomerWithSaleAccess && this.bulkPriceQuantity && this.upsell && this.distanceForOffer && this.distanceForOffer > 0;
    },
    isCustomerWithSaleAccess() {
      return this.$store.getters.statuses.isCustomerWithSaleAccess;
    },
    /**
     * This ONLY gets the value when this component is mounted,
     * changes to quantity are handled by checkBulkPriceQuantity
     * quantity would benefit from being reworked into state but
     * not enough resource available atm
     */
    quantity() {
      return parseInt(this.$parent.$refs.quantityInputRef.value, 10);
    },
  },
  mounted() {
    this.checkBulkPriceQuantity(this.quantity);
  },
  methods: {
    checkBulkPriceQuantity(inputValue: number) {
      if (this.bulkPriceQuantity) {
        this.upsell = false;
        // Check if inputValue is within range to show upsell
        if (inputValue <= this.bulkPriceQuantity) {
          this.upsell = true;
        }
        // Set distanceForOffer
        this.distanceForOffer = this.bulkPriceQuantity - inputValue;
      }
    },
  },
  template: '#t-product-bulk-price-quantity',
});
